import { baseUrl, baseUrlLogin } from '../services/interceptor';

export const authenticate = user => {
    return baseUrlLogin.post('authenticate', user)
}
export const forogtPassword = user => {
    return baseUrl.post('forget-password', user)
}
export const resetPassword = user => {
    return baseUrl.post('reset-password', user)
}
export const activate = user => {
    return baseUrl.post('activate-account', user)
}
export const changePassword = user => {
    return baseUrl.post('change-password', user)
}
export const handleUserCreateUpdate = (user, mode) => {
    return baseUrl.post(mode === "create" ? "register-user": "updateUser", user)
}
export const usersList = () => {
    return baseUrl.post('getUsersList', {
        "pagination": {
            "currentPage": 0,
            "pageSize": 100
        },
        "sort": {
            "columnName": "emailAddress",
            "orderBy": "DESC"
        }
    })
}
export const getUserProfile = () => {
    return baseUrl.get('get/profile')
}
export const getPermissions = () => {
    return baseUrl.get('getPermissions')
}
export const getDepartmentService = () => {
    return baseUrl.get('getDepartments')
}
export const getAllPermissionsService = () => {
    return baseUrl.get('getAllPermissions')
}
export const getAllUserPermissions = (userId) => {
    return baseUrl.get('getAllUserPermissions?userId=' + userId)
}
export const getUserInfoService = (userId) => {
    return baseUrl.get('get/user/info?id=' + userId)
}

export const changeUserStatusService = (userId,isActivate) => {
    return baseUrl.get('changeUserStatus?userId=' + userId + "&isActivate=" + isActivate)
}
export const logoutUser =() => {
    return baseUrl.post('logout')
}

